var ServiceUtil = {
	getServiceUrl: function(url, serviceName,parentPath = ""){
		//浏览器行为 标准线
		if(window && window.location && window.location.origin){
			let ret = url;
			let servicePath =  serviceName?"/" + serviceName: "";
			if (url){
				if (url.indexOf("http://")==0 || url.indexOf("https://")==0){
					ret = url;
				}else{
					if (url.indexOf("/")!==0){
						url = "/" + url;
					}
					ret = location.origin + parentPath + servicePath + url;
				}
			}
			return ret;
		}else{
			//小程序运行兼容逻辑
			var ret = url;
			if (url){
				if (url.indexOf("http://")==0 || url.indexOf("https://")==0){
					ret = url;
				}else{
					ret = wx.App.baseUrl;
					if (serviceName){
						// 解决应用独立部署时, baseUrl带服务名的问题
						if (ret.indexOf("http://")==0 || ret.indexOf("https://")==0){
							var items = ret.split("://");
							ret = items[0] + "://" + items[1].split("/")[0];
						}
						if (serviceName.indexOf("/")!==0){
							ret += "/";
						}
						ret += serviceName;
					}
					if (url.indexOf("/")!==0){
						ret += "/";
					}
					ret += url;
				}
			}
			return ret;
		}
	},
	
	//要求格式/服务名/xxapp/xx/, 例如/oa/hello-pcxapp/hello-pcx/demo.w, 输出结果/oa/hello-mobileapp/hello-mobile/demo.w,
	toMobileUrl: function(url){
		if (url){
			let items = url.split("/");
			if (items.length >= 4){
				if ((items[2]=="pcxapp" && items[3]=="pcx")
						|| (items[2]=="mobileapp" && items[3]=="pcx")   //兼容/xx/mobileapp/pcx/xxx的情况 
						|| (items[2]=="pcapp" && items[3] == "pc")){
					items[2] = "mobileapp";
					items[3] = "mobile";
				}else{
					if (items[2] == (items[3] + "app")){
						let idx = items[3].lastIndexOf("-");
						if (idx != -1){
							let postfix = items[3].substr(idx);
							if (postfix == "-pcx" || postfix == "-pc"){
								let prefix = items[3].substr(0, idx);
								items[2] = prefix + "-mobileapp";
								items[3] = prefix + "-mobile";
							}
						}
						
					}
				}
				return items.join("/");
			}
		}
		return url;
	},

   	//依次根据defaultExecutor和门户当前岗位查找，如果没有找到使用有权限的第一项，否则使用defaultExecutor||门户当前岗位
   	addExecutor: function(url, defaultExecutor){
   		if (!url || url.indexOf("/") == -1) return url;
   		var urlObj = this._parseUrl(url);
		if (urlObj.search.indexOf("executor=")==0 
			|| urlObj.search.indexOf("&executor=")>0){
			return url;
		}else{
			var executor = this._getExecutor(urlObj.path, defaultExecutor);
			if (executor){
				if (urlObj.search) urlObj.search += "&";
				urlObj.search += "executor=" + encodeURIComponent(executor);
			}
			var ret = urlObj.path || "";
			if (urlObj.search){
				ret += "?" + urlObj.search;
			}
			if (urlObj.hash){
				ret += "#" + urlObj.hash;
			}
			return ret;
		}
   	},
   	
   	_getExecutor: function(url, defaultExecutor){
   		var ret = "";
   		if (url){
   			var path = this._parseUrl(url).path;
   			path = this.toMobileUrl(path);
   			
   			var executors = [];
   			if (defaultExecutor) executors.push(defaultExecutor);
   			if (window && window.justep && window.justep.Util && window.justep.Util.getGlobalValue){
				//获取门户的默认执行者
				var defaultPersonMember = justep.Util.getGlobalValue("portal.defaultPersonMember");
				if (defaultPersonMember && defaultPersonMember.fid){
					executors.push(defaultPersonMember.fid);
				}
			}
   			
   			var menu = this._getMenu();
   			var psms = this._getPersonMembersByUrl(menu, path) || [];
   			
   			for (var i=0; i<executors.length; i++){
   				ret = this._doGetExecutor(psms, executors[i]);
   				if (ret) break;
   			}
   			
   			if (!ret && psms.length>0){
   				ret = psms[0].fid;
   			}
   			
   			if (!ret && executors.length>0){
   				ret = executors[0];
   			}
   		}
   		
   		return ret || "";
   	},
   	
   	_doGetExecutor: function(psms, executor){
   		if (psms && psms.length>0 && executor){
			for (var i=0; i<psms.length; i++){
				var psm = psms[i];
				if (psm && psm.fid
						&& (psm.fid.indexOf(executor) === 0)){
					return psm.fid;
				}
			}
		}
   	},
   	
   	_getPersonMembersByUrl: function(items, url){
   		var ret = null;
	   	if (items){
	   		if (url && (url.substr(-2) != ".w")) url += ".w"; //解决传入的url有时不带.w的问题
	   		for (var i=0; i<items.length; i++){
	   			var item = items[i];
	   			var originUrl = item.originUrl;
	   			if (originUrl){
	   				originUrl = originUrl.split("?")[0];
	   				// 兼容route和originUrl少一个/的情况
	   				if ((originUrl === url) || (originUrl === "/" + url)){
	   					ret = item.personMembers || [];
						break;
					}
				}
				if (item.children){
					ret = this._getPersonMembersByUrl(item.children, url);
					if (ret) break;
				}
		 	}
	   	}
	   	return ret;
   	},   	
   	
   	_getMenu: function(){
   		var menu = (getApp()||{}).menu;
   		if (!menu && window && window.justep && window.justep.Util){
   			menu = window.justep.Util.getGlobalValue("portal.menu");
	   	}
   		return menu;
   	},
   	
   	_parseUrl: function(url){
   		var path=url, search="", hash="";
   		if (path){
   			var i = path.indexOf("#");
   			if (i != -1){
   				hash = path.substr(i+1);
   				path = path.substr(0, i);
   			}
   			i = path.indexOf("?");
   			if (i != -1){
   				search = path.substr(i+1);
   				path = path.substr(0, i);
   			}
   		}
   		return {path: path, search: search||"", hash: hash||""};
   	}
};

export default ServiceUtil;
